<style scoped>
.form-control.listTc {
  color: white !important;
}
.text-primary {
  color: #1a3665 !important;
}
.card {
  border-radius: 10px !important;
}
.card-header {
  border-radius: 10px !important;
}
.bg-info {
  background-color: rgb(21, 144, 204) !important;
}
.bg-success {
  background-color: rgb(32, 171, 49) !important;
}
.bg-warning {
  background-color: rgb(251, 166, 54) !important;
}
.vue-daterange-picker {
  width: 100%;
}
.daterangepicker.dropdown-menu.ltr.show-calendar.show-ranges.show-weeknumbers.openscenter.linked {
  margin-left: 30px !important;
}
.card-welcome {
  /* background: data; */
}
</style>
<template>
  <div>
    <TopCard />
    <Counter :dataDashboard="dataDashboard" />
    <CRow>
      <div class="col-xl-12 col-sm-12 col-lg-12 col-md-12 col-12">
        <div class="row">
          <div class="col-xl-8 col-sm-12">
            <div class="card border-0 shadow-sm pb-1 card-welcome">
              <div
                class="card-header border-0 font-weight-bold d-flex align-items-center justify-content-between">
                <h5 class="font-weight-bold">
                  Grafik Peserta Sertifikasi
                </h5>
                <select name="" id="" class="form-control col-3 listTc bg-primary text-white" @change="pilihTahun($event)">                  
                  <option value="" selected disabled>Pilih Tahun</option>
                  <option v-for="(value, index) in dataTahun" :value="value.value" :key="index">{{value.labelPeriode}}</option>
                  
                </select>
              </div>
              <div class="card-body pb-4 pt-5">
                <div id="chart">
                  <apexchart
                    type="bar"
                    height="250"
                    :options="chartOptions"
                    :series="series"
                  ></apexchart>
                </div>
              </div>
            </div>
          </div>
          <div class="col-xl-4 col-sm-12 d-flex">
            <div class="card border-0 shadow-sm flex-fill">
              <div class="card-header border-0 font-weight-bold text-center">
                <h6 class="font-weight-bold">Grafik Peserta Pelatihan </h6>
              </div>
              <div class="card-body mx-auto">
                <div class="row">
                  <div id="chart">
                    <apexchart
                      type="pie"
                      width="250"
                      :options="chartOptionsFo"
                      :series="seriesFo"
                    ></apexchart>
                  </div>
                </div>
                <div class="row">
                  <div class="mx-auto d-flex mt-2">
                    <p class="mb-0">Total Peserta</p>
                    <p class="font-weight-bold text-primary my-0 ml-2">
                      {{ dataDashboard.pelatihan.jumlahDataPeserta }}
                    </p>
                  </div>
                </div>
                <div class="mt-3">
                  <div class="d-flex align-items-center justify-content-between">
                    <h6 style="color: #008ffb" class="mb-0">Pelatihan LMS</h6>
                    <p class="mb-0 font-weight-bold" style="color: #008ffb">
                      {{ dataDashboard.pelatihan.jumlahDataPesertaLms }}
                    </p>  
                  </div>
                  <div class="d-flex align-items-center justify-content-between">
                    <h6 style="color: #00e396" class="mb-0">Pelatihan Webinar</h6>
                    <p class="mb-0 font-weight-bold" style="color: #00e396">
                      
                      {{ dataDashboard.pelatihan.jumlahDataPesertaWebinar }}
                    </p>  
                  </div>
                  <div class="d-flex align-items-center justify-content-between">
                    <h6 style="color: #feb019" class="mb-0">Pelatihan Offline</h6>
                    <p class="mb-0 font-weight-bold" style="color: #feb019">
                      
                      {{ dataDashboard.pelatihan.jumlahDataPesertaOffline }}
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-12">
            <div class="card border-0 shadow-sm">
              <div
                class="card-header border-0 font-weight-bold d-flex align-items-center"
              >
                <div class="h5 font-weight-bold">Peta Sebaran Test Center</div>
                <div class="ml-auto" style="display:none">
                  <select
                    class="form-control listTc bg-primary text-white"
                    name
                    id
                  >
                    <option>Semua Data</option>
                  </select>
                </div>
              </div>
              <div class="card-body">
                <div id="mapTestCenter" style="height: 300px"></div>
                <p class="card-text mt-2">
                  <b> Test Center</b>
                  <b class="text-primary"> : {{totalTestCenter}} Tempat</b>
                </p>
                <p class="card-text" style="display:none">
                  Provinsi
                  <b class="text-primary mr-4">57 Tempat</b>
                  Kota
                  <b class="text-primary mr-4">57 Tempat</b>
                  Kabupaten
                  <b class="text-primary mr-4">57 Tempat</b>
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </CRow>
  </div>
</template>

<script src="https://cdn.jsdelivr.net/npm/apexcharts"></script>
<script src="https://cdn.jsdelivr.net/npm/vue-apexcharts"></script>

<script>
import BerandaService from "../services/beranda/beranda-service"
import DataTestCenterServices from "../services/datamaster/data-test-center.service"
import FilterData from "../components/dashboard/FilterData";
import TopCard from "../components/dashboard/TopCard";
import Counter from "../components/dashboard/Counter";
import DateRangePicker from "vue2-daterange-picker";
//you need to import the CSS manually (in case you want to override it)
import "vue2-daterange-picker/dist/vue2-daterange-picker.css";
import moment from "moment";
import { CChartPie } from "@coreui/vue-chartjs";
import mapMarker from '@/assets/icons/map-pin-2-fill.svg';
import * as L from 'leaflet'
import * as esri from 'esri-leaflet'
import * as esri_geo from 'esri-leaflet-geocoder'
export default {
  name: "CChartPieExample",
  name: "DateRangePickerDemo",
  components: {
    CChartPie,
    apexchart: VueApexCharts,
    DateRangePicker,    
    FilterData,
    TopCard,
    Counter,
  },
  filters: {
    date(value) {
      if (!value) return "";
      let options = { year: "numeric", month: "long", day: "numeric" };
      return Intl.DateTimeFormat("en-US", options).format(value);
    },
  },
  data() {
    return {
      totalTestCenter: 0,
      dataTahun : [],
      groupMarker : [],
      name : '',
      dataDashboard: {
        pelatihan: {
          jumlahDataPesertaOffline: 0,
          jumlahDataPesertaWebinar: 0,
          persentasiDataPesertaOffline: 0,
          jumlahDataPeserta: 0,
          jumlahDataPesertaLms: 0,
          persentasiDataPesertaLms: 0,
          persentasiDataPesertaWebinar: 0
        },
        keanggotaan: {
          jumlahAnggota: 0
        },
        sertifikasi: {
          jumlahPeserta: 0,
          periode: ''
        },
        rpl: {
          jumlahPeserta: 0,
          periode: ''
        }
      },
      selectDivisi: "Sertifikasi",
      latitude: 0,
      longtitude: 0,

      opens: "center",
      minDate: "2019-05-02 04:00:00",
      maxDate: "2020-12-26 14:00:00",
      // minDate: '',
      // maxDate: '',
      dateRange: {
        startDate: "2019-12-10",
        endDate: "2019-12-20",
      },
      show_ranges: true,
      singleDatePicker: false,
      timePicker: true,
      timePicker24Hour: true,
      showDropdowns: true,
      autoApply: false,
      showWeekNumbers: true,
      linkedCalendars: true,
      alwaysShowCalendars: true,

      series: [
        {
          name: "Sertifikasi Reguler",
          data: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
        },
        {
          name: "Sertifikasi RPL",
          data: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
        },              
      ],
      chartOptions: {
        chart: {
          type: "bar",
          height: 250,
          toolbar: {
            show: false,
          },
        },

        plotOptions: {
          bar: {
            horizontal: false,
            columnWidth: "70%",
            endingShape: "rounded",
          },
        },
        dataLabels: {
          enabled: false,
        },
        legend: {
          show: true,
          labels: {
            colors:['#E38D5F', '#1875F0'],
            useSeriesColors: true
          },
        },

        stroke: {
          show: true,
          width: 2,
          colors: ["transparent"],
        },
        xaxis: {
          categories: [
            "Jan",
            "Feb",
            "Mar",
            "Apr",
            "May",
            "Jun",
            "Jul",
            "Aug",
            "Sep",
            "Oct",
            "Nov",
            "Dec",
          ],
        },
        yaxis: {
          title: {
            // text: "$ (thousands)",
          },
        },
        fill: {
          opacity: 1,
          colors:['#E38D5F', '#1875F0']
        },
        colors:['#E38D5F', '#1875F0'],
        tooltip: {
          y: {
            formatter: function (val) {
              return "" + val + " Peserta";
            },
          },
        },
      },
      seriesFo: [30, 10, 60],
      chartOptionsFo: {
        chart: {
          width: 380,
          type: "pie",
        },
        labels: ["LMS", "Webinar", "Offline"],
        legend: {
          position: "bottom",
          // horizontalAlign: "left"
        },
        dataLabels: {
          horizontalAlign: "left",
        },
        responsive: [
          {
            breakpoint: 480,
            options: {
              chart: {
                width: 200,
              },
              legend: {
                position: "bottom",
              },
            },
          },
        ],
      },
    };
  },
  computed: {
    defaultDatasets() {
      return [
        {
          backgroundColor: ["#41B883", "#E46651", "#00D8FF", "#DD1B16"],
          data: [40, 20, 80, 10],
        },
      ];
    },
  },
  mounted() {
    var  user = JSON.parse(localStorage.getItem('user'));
    // comment console console.log(localStorage.getItem('user'));
    this.name = user.name;
    this.getTahun();
    this.getDataDashboard()
    var tahun = new Date().getFullYear();

    var e = {
      target : {
        value : tahun
      }
    }
    this.pilihTahun(e);
    this.getDataTestCenter();
    this.getCount();
  },
  methods: {
    getCount() {
    
      DataTestCenterServices.getDataTestCenter(0, 1, 'default')
      .then(response => {
        
        
        this.totalTestCenter = response.data.data.totalPages;
      })
      .catch(error => {
        // comment console console.log(error);
      });
    },
    getDataTestCenter() {
      BerandaService.getPetaSebaran()
      .then(response => {
        this.getKoordinat(response.data.data)
      }).catch(error=>{

      })
    },
    pilihTahun(e) {
      let loader = this.$loading.show({
        container: false ? null : this.$refs.formContainer,
        canCancel: true,
        onCancel: this.onCancel,
      });
      BerandaService.getStatistikSertifikasiDanRpl(e.target.value)
      .then(response => {
        this.series = response.data.singleData.series
        loader.hide()
      }).catch(error => {
        // comment console console.log(error)
        loader.hide()
      })
    },
    getTahun() {
      for (let index = 0; index < 10; index++) {
        this.dataTahun.push({
          labelPeriode : 2020+index,
          value : 2020+index
        })
      }
    },
    getDataDashboard() {
      let loader = this.$loading.show({
        container: false ? null : this.$refs.formContainer,
        canCancel: true,
        onCancel: this.onCancel,
      });
      BerandaService.getBeranda('default')
      .then(response => {
        this.dataDashboard = response.data.singleData
        this.seriesFo = [
          this.dataDashboard.pelatihan.persentasiDataPesertaLms,
          this.dataDashboard.pelatihan.persentasiDataPesertaWebinar,
          this.dataDashboard.pelatihan.persentasiDataPesertaOffline
        ]
        // In the same way, update the series option
        
        loader.hide()
      }).catch(error => {
        // comment console console.log(error)
      })
    },
    getKoordinat(data) {
      var vm = this;
      
      var customMarker = L.icon({
        iconUrl: '/img/map-marker-alt-solid.svg',
        iconSize: [20, 40],
        iconAnchor: [14, 43.705878]
      });        
    
      var map = L.map('mapTestCenter').setView(
        [-2.811371193331128, 121.55479501146787]
        , 4
      );

      L.tileLayer("https://{s}.tile.osm.org/{z}/{x}/{y}.png", {
        attribution:
          '&copy; <a href="https://osm.org/copyright">OpenStreetMap</a> contributors'
      }).addTo(map);
      var vm = this;
      // if(this.groupMarker.length > 0) {
      //   data.forEach(element => {
      //     map.removeLayer([element.latitude,element.longitude]);
      //   }) 
      // }

      data.forEach(element => {
        vm.groupMarker.push({
          latitude : element.latitude,
          longitude : element.longitude,
        })
      }) 
      for (let index = 0; index < data.length; index++) {
        var latitude = data[index].latitude;
        var longitude = data[index].longitude;
        var x = parseFloat(latitude);
        var y = parseFloat(longitude); 
        var namaTc = data[index].namaTc;
        L.marker([x, y], { icon: customMarker }).bindPopup(namaTc).addTo(map);
        // var popupLocation1 = new L.LatLng(x, y);

        // var popupContent1 = namaTc,
        // popup1 = new L.Popup();

        // popup1.setLatLng(popupLocation1);
        // popup1.setContent(popupContent1 );
        // map.addLayer(popup1);
      }
      // data.forEach(element => {
      //   var x = parseFloat(element.latitude);
      //   var y = parseFloat(element.longitude);    
      //   L.marker([x, y], { icon: customMarker }).addTo(map);
      //   var popupLocation1 = new L.LatLng(x, y);

      //   var popupContent1 = element.namaTc,
      //   popup1 = new L.Popup();

      //   popup1.setLatLng(popupLocation1);
      //   popup1.setContent(popupContent1 );
      //   map.addLayer(popup1);
      //   alert(element.namaTc)
      // });

      var arcgisOnline = esri_geo.arcgisOnlineProvider();
      var searchControl = esri_geo.geosearch({
          providers: [arcgisOnline]
      }).addTo(map);
      var results = L.layerGroup().addTo(map);

      // searchControl.on('results', function(data){
      //   results.clearLayers();
      //   for (var i = data.results.length - 1; i >= 0; i--) {
      //     results.addLayer(L.marker(data.results[i].latlng));
      //     marker = L.marker((data.results[i].latlng), { icon: customMarker }).addTo(map);
      //     latitude = data.results[i].latlng.lat;
      //     longitude = data.results[i].latlng.lng;
      //   }
      // });
      
      
      

      
    },
  },
};
</script>